import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { BusinessLinkType } from '@meniudigital/shared'
import Setting from '../Setting'
import { useBusinessLinks } from '../hooks/useBusinessLinks'

type SocialMediaSetting = {
  type: BusinessLinkType
  name: string
  placeholder: string
}

const allSocialMediaSettings: SocialMediaSetting[] = [
  {
    type: BusinessLinkType.PhoneNumber,
    name: 'Numărul de Telefon',
    placeholder: `Numărul tău de telefon`,
  },
  {
    type: BusinessLinkType.Facebook,
    name: 'Pagina de Facebook',
    placeholder: `Linkul paginii (ex: https://facebook.com/mybistro)`,
  },
  {
    type: BusinessLinkType.Instagram,
    name: 'Pagina de Instagram',
    placeholder: `Linkul paginii (ex: https://instagram.com/mybistro)`,
  },
  {
    type: BusinessLinkType.TripAdvisor,
    name: 'Pagina de TripAdvisor',
    placeholder: `Linkul paginii (ex: https://tripadvisor.com/demo_restaurant.html)`,
  },
]

export default function SocialMediaSettings() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const { invalidFields, isBusinessInfoVisible, toggleBusinessMedium, updateBusinessMediumLinkUrl, isUrlInvalid, testValidity } =
    useBusinessLinks({ user, dispatch })

  if (!user) {
    return null
  }

  return (
    <>
      <div className="setting-question nomargin">Ce informații despre businessul tău dorești să apară pe meniu?</div>
      <div className="settings-group">
        {allSocialMediaSettings.map(({ type, name, placeholder }) => (
          <Setting
            key={type}
            title={name}
            iconPath={`/logos/${type}.png`}
            isEnabled={isBusinessInfoVisible(type)}
            value={(user?.businessInfo || []).find(x => x.type === type)?.url}
            placeholder={placeholder}
            onValueUpdate={newValue => updateBusinessMediumLinkUrl(newValue, type)}
            onEveryKeyPress={newValue => testValidity(newValue, type)}
            onToggle={() => toggleBusinessMedium(type)}
            hasError={(isUrlInvalid(type) || invalidFields?.[type]) && type !== BusinessLinkType.PhoneNumber}
          />
        ))}
      </div>
    </>
  )
}
